// extracted by mini-css-extract-plugin
export default {"tabs":"NavTabs_tabs_YaxpV","docked":"NavTabs_docked_dku_h"};